export const getColourGradient = (colour: string): string => {
    const lowerCaseColour = colour.toLowerCase()
    if (lowerCaseColour === 'multicolour') {
        return `conic-gradient(#0F50F6, #FF0000, #FF6003, #FFD707, #E9B707, #FF007A, #2FB20E, #0FE76B)`
    }
    const gradientLookup: {
        [key: string]: {
            start: string
            end: string
        }
    } = {
        black: {
            start: '#3D3D3D',
            end: '#0A0A0A',
        },
        grey: {
            start: '#898585',
            end: '#565252',
        },
        silver: {
            start: '#ECECEC',
            end: '#B9B9B9',
        },
        white: {
            start: '#FFFCFC',
            end: '#EEEAEA',
        },
        blue: {
            start: '#2F61C4',
            end: '#002E91',
        },
        red: {
            start: '#EC2020',
            end: '#B90000',
        },
        yellow: {
            start: '#FFC939',
            end: '#E39606',
        },
        green: {
            start: '#5FA34E',
            end: '#2C701B',
        },
        beige: {
            start: '#FBE0B3',
            end: '#C8AD80',
        },
        brown: {
            start: '#964B00',
            end: '#631800',
        },
        gold: {
            start: '#D0B050',
            end: '#9D7D1D',
        },
        bronze: {
            start: '#CD7F32',
            end: '#9A4C00',
        },
        orange: {
            start: '#FFA31B',
            end: '#E47000',
        },
        pink: {
            start: '#FFDAE5',
            end: '#E6A7B2',
        },
        purple: {
            start: '#9527A7',
            end: '#620074',
        },
        turquoise: {
            start: '#5AFAEA',
            end: '#27C7B7',
        },
        navy: {
            start: '#1A1A9A',
            end: '#000067',
        },
        maroon: {
            start: '#9A1A1A',
            end: '#670000',
        },
        magenta: {
            start: '#FF1AFF',
            end: '#E600E6',
        },
        indigo: {
            start: '#651A9C',
            end: '#320069',
        },
        burgundy: {
            start: '#9A1A3A',
            end: '#670007',
        },
    }

    const start = gradientLookup[lowerCaseColour]?.start
    const end = gradientLookup[lowerCaseColour]?.end
    return start && end ? `linear-gradient(90deg, ${start} 0%, ${end} 100%)` : lowerCaseColour
}
